/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CameraFormat { 
    cameraScheduleRuleType?: CameraFormat.CameraScheduleRuleTypeEnum;
    currentPhaseOne?: number;
    currentPhaseTwoHQ?: number;
    currentPhaseTwoLQ?: number;
    currentPhaseTwoMQ?: number;
    dataRateHQ?: number;
    dataRateLQ?: number;
    dataRateMQ?: number;
    dataStorage?: number;
    formatId?: number;
    information?: string;
}
export namespace CameraFormat {
    export const CameraScheduleRuleTypeEnum = {
        Picture: 'PICTURE',
        Video: 'VIDEO'
    } as const;
    export type CameraScheduleRuleTypeEnum = typeof CameraScheduleRuleTypeEnum[keyof typeof CameraScheduleRuleTypeEnum];
}


export type CameraScheduleRuleTypeEnum = typeof CameraFormat.CameraScheduleRuleTypeEnum[keyof typeof CameraFormat.CameraScheduleRuleTypeEnum];
